export enum API_URLS {
  AUTH_LOGIN = "/auth/login",
  AUTH_CHECK = "/auth/check",
  AUTH_USER_MSP = "/auth/user-msp",
  AUTH_PSA_STATUS = "/auth/psa-status",
  AUTH_TEST_AUTOTASK = "/auth/test-autotask",
  AUTH_SAVE_AUTOTASK = "/auth/save-autotask",
  AUTH_TEST_HALO = "/auth/test-halo",
  AUTH_TEST_HALO_PERMISSIONS = "/auth/test-halo-permissions",
  AUTH_SAVE_HALO = "/auth/save-halo",
  AUTH_TEST_CONNECTWISE = "/auth/test-connectwise",
  AUTH_SAVE_CONNECTWISE = "/auth/save-connectwise",
  AUTH_TEST_SUPEROPS = "/auth/test-superops",
  AUTH_SAVE_SUPEROPS = "/auth/save-superops",
  AUTH_TEST_ITGLUE = "/auth/test-itglue",
  AUTH_SAVE_ITGLUE = "/auth/save-itglue",
  AUTH_TEST_NABLE = "/auth/test-nable",
  AUTH_SAVE_NABLE = "/auth/save-nable",
  AUTH_TEST_NINJAONE = "/auth/test-ninjaone",
  AUTH_SAVE_NINJAONE = "/auth/save-ninjaone",
  AUTH_TEST_DATTO = "/auth/test-datto",
  AUTH_SAVE_DATTO = "/auth/save-datto",

  GET_TICKETS = "/tickets",
  GET_TECHNICIAN_GROUP_LIST = "/techgroup-list",
  GET_TECHNICIAN_LIST = "/technician-list",
  GET_CLIENTS_LIST = "/clients-list",
  GET_NINJAONE_USERS = "/ninjaone-users",

  CREATE_TICKET_THREAD = "/ai-threads/ticket",
  TICKET_AI_OVERVIEW = "/ai-threads/ticket-ai-overview",
  TICKET_QUALITY_REVIEW = "/ai-threads/ticket-quality-review",
  HANDLE_MESSAGE = "/ai-threads/message",
  CANCEL_TURN = "/ai-threads/:aiThreadId/cancel",
  DOWNLOAD_TABLE_PDF = "/ai-threads/table-download/pdf",
  DOWNLOAD_THREAD_CSV_EXPORT = "/ai-threads/:aiThreadId/csv-export/:exportId",
  DOWNLOAD_THREAD_PDF_EXPORT = "/ai-threads/:aiThreadId/pdf-export/:exportId",
  GET_LINEAR_TASK_ASSIGNEES = "/ai-threads/linear-task-assignees",
  GET_LINEAR_TASK_TRACE_URL = "/ai-threads/:aiThreadId/linear-task-trace-url",
  FILE_LINEAR_TASK = "/ai-threads/:aiThreadId/file-linear-task",
  GET_RESEARCH_REPORT_JOBS = "/api/research-report-jobs",
  GET_RESEARCH_REPORT_JOBS_REQUESTED_BY = "/api/research-report-jobs/requested-by",

  GET_TICKET_THREAD = "/ai-threads/ticket/:ticketId",
  GET_TICKET_THREADS = "/ai-threads/ticket/:ticketId/threads",
  DELETE_AI_THREAD = "/ai-threads/:aiThreadId",
  GET_TOOL_AUDIT_LOGS = "/ai-threads/:aiThreadId/tool-audit-logs",
  GET_TICKET_TOOL_AUDIT_LOGS = "/ai-threads/ticket/:ticketId/tool-audit-logs",
  GET_USER_THREAD = "/ai-threads/user/:userId",
  CREATE_USER_THREAD = "/ai-threads/user",
  GET_USER_THREADS = "/ai-threads/user/:userId/threads",
  RENAME_USER_THREAD = "/ai-threads/:aiThreadId/title",

  GET_CUSTOMER_APPLICATIONS = "/customers/:customerId/applications",
  GET_APPLICATION_DETAILS = "/applications/:applicationId",
  GET_APPLICATION_PERMISSIONS = "/applications/:applicationId/permissions",
  GET_APPLICATION_ACTIONS = "/customers/:customerId/applications/:applicationId/actions",
  UPDATE_ACTION_PERMISSION = "/customers/:customerId/applications/:applicationId/actions/:actionName/permission",
  UPDATE_ACTION_CONFIG = "/customers/:customerId/applications/:applicationId/actions/:actionName/config",
  UPDATE_APPLICATION_STATE = "/customers/:customerId/applications/:applicationId/state",
  ADD_APPLICATION_TO_CUSTOMER = "/customers/:customerId/applications/:applicationId",
  REMOVE_APPLICATION_FROM_CUSTOMER = "/customers/:customerId/applications/:applicationId",
  GET_PLATFORMS = "/platforms",
  GET_PLATFORM_ACTIONS = "/platforms/:type/:name/actions",
  GET_APPLICATION_STATS = "/customers/:customerId/stats",
  GET_PLATFORM_INTEGRATION_STATUS = "/customers/:customerId/platform-integration",
  GET_AUDIT_LOGS = "/audit-logs",
  GET_PILLS = "/pills",
  GET_SUGGESTIONS = "/suggestions",
  CREATE_AI_THREADS_FOR_QUEUE = "/tickets/create-ai-threads",
  GET_QUEUE_AUTO_MODE = "/tickets/queue-auto-mode",
  UPDATE_QUEUE_AUTO_MODE = "/tickets/queue-auto-mode",
}
